import type React from 'react';

import { BrandShowcase } from './BrandShowcase';

type PageLayoutProps = {
  children: React.ReactNode;
};

export const PageLayout = ({ children }: PageLayoutProps) => {
  return (
    <div className="grid min-h-screen grid-cols-[60%_40%] bg-white max-lg:grid-cols-1">
      {/* 左侧品牌展示区域 */}
      <div className="max-lg:hidden">
        <BrandShowcase />
      </div>

      {/* 右侧内容区域 */}
      <div>{children}</div>
    </div>
  );
};
